import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class MainService {
    public server_url: string = environment.baseURL;
    public image_url: string = environment.image;

    constructor() {
    }

    public convertStrintToDate(fechaHora: String): Date {
        let fechaHoraArray = fechaHora.split(' ');
        let fechaArray = fechaHoraArray[0].split('/');
        let horaArray = fechaHoraArray[1].split(':');

        let date = new Date();
        date.setFullYear(+fechaArray[2], +fechaArray[1] - 1, +fechaArray[0]);
        date.setHours(+horaArray[0], +horaArray[1], +horaArray[2]);
        return date;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/main.service.ts